<form
  *transloco="let t; read: 'widgets.section-selector'"
  [formGroup]="form"
  class="section-selector__container"
  [class.section-selector__container--compact]="compact"
>
  <div class="section-selector__title" [class.section-selector__title--compact]="compact">
    @if (compact) {
      <span class="section-selector__label">{{ t('title') }}</span>
    } @else if (forFilters) {
      {{ t('title-left') }}
    } @else {
      <h3>{{ t('title') }}</h3>
    }

    <div [class.section-selector__toggle--right-alligned]="forFilters && !compact">
      <xi-toggle-switch
        formControlName="isOn"
        color="CX"
        [isLabelLeft]="true"
        label="{{ forFilters && !compact ? t('section-filtering') : '' }}"
      >
      </xi-toggle-switch>
    </div>
  </div>

  @if (isOn) {
    <div formArrayName="rows" [class.section-selector__rows--compact]="compact">
      @for (row of formRows.controls; track row; let i = $index) {
        @if (!compact || i === 0) {
          <div formGroupName="{{ i }}" class="field-row" [class.field-row--compact]="compact">
            @if (!compact) {
              @if ((i > 0 || formRows.controls.length > 1) && !disabled) {
                <xi-icon-button icon="cancel_circle" (onClick)="onRemoveRow(i)"></xi-icon-button>
              } @else {
                <xi-icon-button icon="cancel_circle" disabled="true"></xi-icon-button>
              }
            }
            <xi-dropdown
              formControlName="field"
              [stretch]="false"
              [data]="fieldDs"
              id="rowForm-field-{{ i }}"
            ></xi-dropdown>
            <xi-dropdown
              formControlName="buckets"
              id="rowForm-buckets-{{ i }}"
              [stretch]="false"
              [select]="'multiSelectAll'"
              [data]="bucketMap.get(row.controls.field.value)"
            ></xi-dropdown>
          </div>
        }
      }
      @if (!compact && formRows.controls.length < fieldDs.length && !disabled) {
        <xi-icon-button icon="add_circle" (onClick)="onAddRow()"></xi-icon-button>
      }
    </div>
  }
</form>
